import { AnimatePresence, motion } from 'motion/react'
import { NavLink } from 'react-router'
import { useSession } from '../store/session'

/** "Lv 4" in the header, linking to the profile; announces a level-up when one just happened. */
export function LevelPill() {
  const me = useSession((s) => s.me)
  const levelUp = useSession((s) => s.levelUp)
  const dismiss = useSession((s) => s.dismissLevelUp)
  if (!me) return null
  return (
    <>
      <NavLink
        to="/me"
        className="inline-flex items-center rounded-full bg-sky-100 px-2.5 py-1 text-xs font-black tabular-nums text-sky-700 dark:bg-sky-950/60 dark:text-sky-200"
        aria-label={`Account level ${me.progress.level}`}
      >
        Lv {me.progress.level}
      </NavLink>
      <AnimatePresence>
        {levelUp !== null && (
          <motion.button
            type="button"
            onClick={dismiss}
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            className="fixed inset-x-0 top-[calc(env(safe-area-inset-top)+3.5rem)] z-30 mx-auto w-fit rounded-full bg-sky-600 px-4 py-2 text-sm font-black text-white shadow-lg"
          >
            Level {levelUp}! {me.progress.title}
          </motion.button>
        )}
      </AnimatePresence>
    </>
  )
}
